





































































































































































import { Component, Vue } from 'vue-property-decorator'
import Nav from '@/components/navbar/index.vue'
import { ITodo } from '@/types/todo/types'
import { listTodo, updateTodo } from '@/api/todo'
import { openListTodo, openUpdateTodo } from '@/api/open/todo'
import { filterArray, priorities, statusGroup, todoList } from '@/constant/todoConstant'
import { GROUP_ID, TOKEN, USER } from '@/constant/storageConstant'
import { convertToTodo, handleTodoList } from '@/utils/todo'
import { openFreshToken } from '@/api/open/token'
import TodoNav from '@/views/todo/component/TodoNav.vue'

@Component({
  name: 'TodoList',
  components: {
    Nav,
    TodoNav
  }
})
export default class extends Vue {
  private todoList: ITodo[] = todoList
  private filterArray = filterArray
  private listLoading = true

  private isOpen = false
  private todoFormVisible = false
  private editLoading = false
  private todoForm: any = {}
  private oldTodo: ITodo | undefined
  private statusGroup = statusGroup
  private priorities = priorities
  private refreshTokenTimer: any

  created () {
    this.refreshTokenTimer = setInterval(async function () {
      const token = localStorage.getItem(TOKEN)
      if (token !== null) {
        const result = await openFreshToken(token)
        if (result.status) {
          // 刷新token
          localStorage.setItem(TOKEN, result.data)
        }
      }
    }, 600000)
  }

  mounted () {
    // html加载完成后执行。执行顺序：子组件-父组件
    const isLogin = localStorage.getItem(USER) !== null
    if (!isLogin) {
      const token = this.$route.query.token
      if (typeof token !== 'string') {
        this.$router.push({
          path: '/login'
        })
        return
      }
      const tokenStr = token.toString()
      if (/^(\w|-)+\.(\w|-)+\.(\w|-)+$/.test(tokenStr)) {
        // jwt获取数据
        this.getOpenTodoList(tokenStr)
      } else {
        this.$router.push({
          path: '/login'
        })
      }
    } else {
      // 已登录，加载初始数据
      this.getTodoList()
    }
  }

  beforeDestroy () {
    // 清除定时刷新，不清除会一直运行，关闭页面也会定时刷新
    const token = localStorage.getItem(TOKEN)
    if (token !== null) {
      localStorage.clear()
    }
    clearInterval(this.refreshTokenTimer)
  }

  private disableEditButton (status: number) {
    return this.isOpen && status !== 1 && status !== 10
  }

  private handleEdit (todo: ITodo) {
    this.oldTodo = todo
    this.todoForm = {
      id: todo.id,
      task: todo.task,
      priority: todo.priority,
      value: todo.value,
      estimateTime: todo.estimateTime,
      realityTime: todo.realityTime,
      status: todo.status
    }
    this.todoFormVisible = true
  }

  private setEditLoading (status: boolean) {
    this.editLoading = status
  }

  private async submitEdit () {
    this.editLoading = true
    // 模拟请求耗时
    const setEditLoading = this.setEditLoading
    setTimeout(function () {
      setEditLoading(false)
    }, 1000)
    if (this.oldTodo !== undefined &&
      (this.oldTodo.task !== this.todoForm.task ||
        this.oldTodo.priority !== this.todoForm.priority ||
        this.oldTodo.value !== this.todoForm.value ||
        this.oldTodo.estimateTime !== this.todoForm.estimateTime ||
        this.oldTodo.realityTime !== this.todoForm.realityTime ||
        this.oldTodo.status !== this.todoForm.status)) {
      if (this.isOpen) {
        const token = localStorage.getItem(TOKEN)
        if (token === null) {
          this.$message.error('你无权操作')
          return
        }
        const param = {
          id: this.todoForm.id,
          task: undefined,
          priority: undefined
        }
        if (this.oldTodo.task !== this.todoForm.task) {
          param.task = this.todoForm.task
        }
        if (this.oldTodo.priority !== this.todoForm.priority) {
          param.priority = this.todoForm.priority
        }
        const result = await openUpdateTodo(token, param)
        if (result.status) {
          this.$message.success('修改成功')
          const idx = this.todoList.indexOf(this.oldTodo)
          this.todoList.splice(idx, 1)
          this.todoList.push(convertToTodo(result.data))
        }
      } else {
        const param = {
          id: this.todoForm.id,
          task: undefined,
          priority: undefined,
          value: undefined,
          estimateTime: undefined,
          realityTime: undefined,
          status: undefined
        }

        if (this.oldTodo.task !== this.todoForm.task) {
          param.task = this.todoForm.task
        }
        if (this.oldTodo.value !== this.todoForm.value) {
          param.value = this.todoForm.value
        }
        if (this.oldTodo.priority !== this.todoForm.priority) {
          param.priority = this.todoForm.priority
        }
        if (this.oldTodo.estimateTime !== this.todoForm.estimateTime) {
          param.estimateTime = this.todoForm.estimateTime
        }
        if (this.oldTodo.realityTime !== this.todoForm.realityTime) {
          param.realityTime = this.todoForm.realityTime
        }
        if (this.oldTodo.status !== this.todoForm.status) {
          param.status = this.todoForm.status
        }
        if (param.priority !== undefined || param.estimateTime !== undefined || param.value !== undefined) {
          if (this.todoForm.status !== 10) {
            this.$message.error('必须改为等待状态，进行动态规划')
            return
          }
          param.status = this.todoForm.status
        }
        if (param.realityTime !== undefined) {
          if (this.todoForm.status !== 100) {
            this.$message.error('必须改为完成状态，才能设置完成时间')
            return
          }
          param.status = this.todoForm.status
        }
        const result = await updateTodo(param)
        if (result.status) {
          const idx = this.todoList.indexOf(this.oldTodo)
          this.todoList.splice(idx, 1)
          this.todoList.push(convertToTodo(result.data))
          this.$message.success('修改成功')
        }
      }
    }
    this.todoFormVisible = false
    this.editLoading = false
  }

  private async getOpenTodoList (token: string) {
    this.listLoading = true
    const result = await openListTodo(token)
    if (result.status) {
      this.isOpen = true
      // openAdd使用
      localStorage.setItem(TOKEN, token)
    }
    handleTodoList(result, this.todoList)
    this.listLoading = false
  }

  private async getTodoList () {
    this.listLoading = true
    const param = {
      groupId: parseInt(localStorage.getItem(GROUP_ID) || '0')
    }
    const result = await listTodo(param)
    if (result.status) {
      this.isOpen = false
    }
    handleTodoList(result, this.todoList)
    this.listLoading = false
  }

  private descPriority (priority: number) {
    if (priority >= 1 && priority <= 3) {
      return '重要且紧急-'.concat(priority.toString())
    } else if (priority >= 4 && priority <= 6) {
      return '紧急不重要-'.concat((priority - 3).toString())
    } else if (priority >= 7 && priority <= 9) {
      return '重要不紧急-'.concat((priority - 6).toString())
    } else {
      return '既不重要也不紧急'
    }
  }

  private descStatus (status: number) {
    if (status === 1) {
      return '初始'
    } else if (status === 10) {
      return '等待'
    } else if (status === 20) {
      return '处理中'
    } else if (status === 50) {
      return '已删除'
    } else {
      return '已完成'
    }
  }

  private filterHandler (value: string, row: any, column: any) {
    const property = column['property']
    return row[property] === value
  }

  private changeStatusForSort (s: number) {
    // 1>20>10>100>50
    if (s === 1) {
      return 5
    } else if (s === 10) {
      return 3
    } else if (s === 20) {
      return 4
    } else if (s === 50) {
      return 1
    } else {
      return 2
    }
  }

  private sortStatusCp (a: ITodo, b: ITodo) {
    const aStatus = this.changeStatusForSort(a.status)
    const bStatus = this.changeStatusForSort(b.status)
    if (aStatus > bStatus) {
      return 1
    } else if (aStatus < bStatus) {
      return -1
    } else {
      if (a.priority < b.priority) {
        return 1
      } else if (a.priority > b.priority) {
        return -1
      } else {
        const aCp = parseFloat(a.cp)
        const bCp = parseFloat(b.cp)
        return aCp > bCp ? 1 : -1
      }
    }
  }
}
